if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    constructor() {
      super();

      if (!this.hasAttribute('available')) return;

      this.onClickRefreshList = this.onClickRefreshList.bind(this);
      this.fetchAvailability(this.dataset.variantId);

    }

    fetchAvailability(variantId) {
      let rootUrl = this.dataset.rootUrl;
      if (!rootUrl.endsWith("/")) {
        rootUrl = rootUrl + "/";
      }
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

      fetch(variantSectionUrl)
        .then(response => response.text())
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          this.renderPreview(sectionInnerHTML);

        })
        .catch(e => {
          const button = this.querySelector('button');
          if (button) button.removeEventListener('click', this.onClickRefreshList);
          this.renderError();
        });
    }

    onClickRefreshList(evt) {
      this.fetchAvailability(this.dataset.variantId);
    }

    renderError() {
      this.innerHTML = '';
			if ( this.querySelector('button') ) {
	      this.querySelector('button').addEventListener('click', this.onClickRefreshList);
			}
    }

    renderPreview(sectionInnerHTML) {
      const drawer = document.querySelector('.pickup-availability-drawer');
      if (drawer) drawer.remove();
      if (!sectionInnerHTML.querySelector('.pickup-availability-information')) {
        this.innerHTML = "";
        this.removeAttribute('available');
        return;
      }

      const dialog = document.getElementById('Pickup-Availability');
      if (dialog instanceof HTMLDialogElement && dialog.open) {
        dialog.close();
      }

      this.innerHTML = sectionInnerHTML.querySelector('.pickup-availability-information').innerHTML;
      this.setAttribute('available', '');

      const sideAvailability = sectionInnerHTML.querySelector('.side-availability');
      if (dialog && sideAvailability) {
        dialog.innerHTML = sideAvailability.innerHTML;
      }

      if (dialog instanceof HTMLDialogElement) {
        if (!dialog.dataset.pickupCloseBound) {
          dialog.dataset.pickupCloseBound = 'true';
          dialog.addEventListener('close', () => {
            document.body.classList.remove('open-cc');
            dialog.classList.remove('active');
          });
        }

        const opener = this.querySelector('button.pickup-availability-information__button');
        if (opener) {
          opener.addEventListener('click', (evt) => {
            evt.preventDefault();
            if (dialog.open) {
              dialog.close();
            } else {
              document.body.classList.add('open-cc');
              dialog.classList.add('active');
              dialog.showModal();
              const closeBtn = dialog.querySelector('.side-panel-close');
              if (closeBtn) {
                requestAnimationFrame(() => closeBtn.focus());
              }
            }
          });
        }
      }
    }
  });
}
